module.exports = __webpack_public_path__ + "static/bgHeroMantenimiento1-2f781cc0b0cbed964017951361e7e0b0.jpg";